/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LeagueTeamStatus = {
    PENDING: 'PENDING',
    REGISTERED: 'REGISTERED',
    ACTIVE: 'ACTIVE',
    WITHDRAWN: 'WITHDRAWN',
    DISQUALIFIED: 'DISQUALIFIED'
} as const;
export type LeagueTeamStatus = typeof LeagueTeamStatus[keyof typeof LeagueTeamStatus];


export function instanceOfLeagueTeamStatus(value: any): boolean {
    for (const key in LeagueTeamStatus) {
        if (Object.prototype.hasOwnProperty.call(LeagueTeamStatus, key)) {
            if (LeagueTeamStatus[key as keyof typeof LeagueTeamStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeagueTeamStatusFromJSON(json: any): LeagueTeamStatus {
    return LeagueTeamStatusFromJSONTyped(json, false);
}

export function LeagueTeamStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueTeamStatus {
    return json as LeagueTeamStatus;
}

export function LeagueTeamStatusToJSON(value?: LeagueTeamStatus | null): any {
    return value as any;
}

export function LeagueTeamStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LeagueTeamStatus {
    return value as LeagueTeamStatus;
}

